import * as React from 'react';
import {
  NODE_PARAGRAPH,
  render,
  MARK_LINK,
  NODE_UL,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';

import '../../css/custom.css';
import LinkResolver from '../../helpers/link-resolver';

export default function JobRow({ blok }) {
  return (
    <div
      className="mt-[40px] lg:mt-[60px] px-4 lg:px-16"
      key={`job-description-${blok._uid}`}
    >
      <FancyTitle
        text={blok.Title}
        tag={blok.headline_level || 'h3'}
        fontSize="lg:text-4xl"
        marginBottom="mb-6"
      />

      <div className="job-detail">
        {render(blok.content, {
          markResolvers: {
            [MARK_LINK]: LinkResolver,
          },
          nodeResolvers: {
            // eslint-disable-next-line react/no-unstable-nested-components
            [NODE_UL]: (children) => (
              <ul className="lg:columns-2 lg:gap-x-16 lg:gap-y-1 grid grid-cols-1 lg:grid-cols-2 mb-8 pt-6">
                {children}
              </ul>
            ),
            // eslint-disable-next-line react/no-unstable-nested-components
            [NODE_PARAGRAPH]: (children) => (
              <p className="first-of-type:mt-0 last-of-type:mb-0">
                {children}
              </p>
            ),
          },
        })}
      </div>

      {blok.button_text && blok.button_link?.url && (
        <a
          href={blok.button_link.url}
          title={blok.button_link?.link_title || undefined}
          target="_blank"
          rel="noreferrer"
          className="button-general"
        >
          {blok.button_text}
          <span> →</span>
        </a>
      )}
    </div>
  );
}
